'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'sword';
var width = 512;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = ['M144 272L400 16 512 0 496 112 240 368l-96-96z', 'M96 512L0 416l32-32 32 16 56-56L64 256l32-32L288 416l-32 32-88-56-56 56 16 32L96 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;